import { AutoImportFormData } from "../../Context/AutoImportFormContext";
//util funcitons that check if all required inputs are filled
export const validateGeneralInfo = (data: AutoImportFormData): boolean => {
  const { generalInformation } = data;
  
  return Boolean(
    generalInformation.description?.trim() &&
    generalInformation.industryIdentifier?.trim() &&
    generalInformation.client &&
    generalInformation.productType &&
    generalInformation.autoImportType
  );
};

export const validateSourceFile = (data: AutoImportFormData): boolean => {
  const { sourceFile } = data;
  
  return Boolean(sourceFile.connection && sourceFile.fileSelectorMode  && sourceFile.fileSelector);
};

export const validateValidations = (data: AutoImportFormData): boolean => {
  const { validations } = data;
  
  return (
    validations.validateRepeatedFileName !== undefined &&
    validations.validateRepeatedChecksum !== undefined
  );
};

export const pgpDecryptionValidations = (data: AutoImportFormData): boolean => {
  const { pgpDecryption } = data;
  
  return pgpDecryption.usePgpDecryption
    ? Boolean(pgpDecryption.pgpPassPhrase?.trim()) && Boolean(pgpDecryption.pgpPrivateKey?.trim())
    : true;
};

export const validateForm = (data: AutoImportFormData): boolean => {
  return (
    validateGeneralInfo(data) &&
    validateSourceFile(data) &&
    validateValidations(data) &&
    pgpDecryptionValidations(data)
  );
};